module.exports = __webpack_public_path__ + "img/white-logo-transparent-bg.07dddffe.png";